
// types of action
const Types = {
  SIDEBAR_TOGGLE: "SIDEBAR_TOGGLE",
};

const toggleSidebar = () => ({
  type: Types.SIDEBAR_TOGGLE,
});


const Actions = {
  toggleSidebar
}

export {Types, Actions}